import React, { useState } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import { Button } from 'react-bootstrap';
import SelectModules from 'react-select';
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const MapingGroupsComp = (props) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [idModules, setidModules] = useState([]);
  const [postModules, setpostModules] = useState([]);

  const handleSelectChange = (selectedOption) => {
    // Map selected options to a new array format with custom keys
    const newIdModules = selectedOption.map((option) => ({
      value: option.value,
      label: option.label,
    }));
    setidModules(newIdModules);

    const newPostModules = selectedOption.map((option) => ({
      idModules: option.value,
    }));
    setpostModules(newPostModules);
  };

  const handleMaping = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      idGroups: props?.group?.id,
      modules: postModules,
    };

    // console.log(requestBody);
    // return false;

    axios({
      url: '/mapping-groups/mapping-module-by-groups',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully created Maping Module!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  // console.log(postModules)

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="module" className="col-sm-2 col-form-label required">
          Modules
        </label>
        <div className="col-12">
          <SelectModules
            id="module"
            value={idModules}
            onChange={handleSelectChange}
            options={props.modules}
            placeholder="Cari modules"
            isMulti={true}
          />
        </div>
      </div>
      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleMaping()}
          >
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MapingGroupsComp;
